import React, { Component } from "react";
import "./css/ResultScreenMobile.css";

import CalculateIcon from "./src/Calculator_icon.png";

export default class TableInformationPc extends Component {
  render() {
    return (
      <>
        <div className="container">
          <div className="row">
            <div className="col-sm-auto">
              <img
                className="resultScreen-mobile-info-body-icon"
                src={this.props.current.iconlink}
                alt=""
              />
            </div>
            <div className="col">
              <div
                className="resultScreen-mobile-info-header"
                style={{ margin: "0px" }}
              >
                <div className="row header-text">{this.props.current.name}</div>

                <div
                  className="table-calculator-container"
                  onClick={this.props.onCalculate}
                >
                  <img
                    className="table-calculator-icon"
                    src={CalculateIcon}
                    alt=""
                  />

                  <div className="table-calculator-text">เครื่องคำนวณ</div>
                </div>
              </div>

              <div className="row">
                <table className="table table-borderless">
                  <thead style={{ backgroundColor: "#E6E7E8" }}>
                    <tr>
                      <th scope="col">รุ่น</th>
                      <th scope="col">ลาย</th>
                      <th scope="col">สี</th>
                      <th scope="col">
                        <div>ขนาด (ซม.)</div>
                        <div>(หนา * กว้าง * ยาว)</div>
                      </th>
                      <th scope="col">
                        <div>จำนวน</div>
                        <div>(แผ่น/ตร.ม.)</div>
                      </th>
                    </tr>
                  </thead>
                  <tbody style={{ backgroundColor: "white" }}>
                    {this.props.data.map((data) =>
                      data.track === this.props.current.track ? (
                        <tr key={data.id}>
                          <th scope="col">{data.class}</th>
                          <th scope="col">{data.striped}</th>
                          <th scope="col">{data.color}</th>
                          <th scope="col">{data.size}</th>
                          <th scope="col">{data.numpersqm}</th>
                        </tr>
                      ) : null
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
